module.exports = __webpack_public_path__ + "static/img/loginbg.9772cec7.jpg";